import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { fetchStatiticsIncidenceOperatorDetailedFilterAction } from "../../../../../redux/actions/statistics/statistics";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { Skeleton } from "../../../../common/skeleton/skeleton";
import { CustomTableList } from "../../../dailyCharge/customTableList/tableList";
import { StatisticsOperatorIncidenceDetailedListIncidenceTypeItem } from "./incidenceType/incidenceType";
import { StatisticsOperatorIncidenceDetailedListStyle } from "./listStyle.jss";

export const StatisticsOperatorIncidenceDetailedList = () => {
    const theme = useTheme();
    const style = StatisticsOperatorIncidenceDetailedListStyle({ theme });
    const dispatch = useAppDispatch();
    const { loading, operatorStatistics } = useAppSelector((store) => store.statisticsOperatorIncidenceDetailed.data);
    const { t } = useTranslation("common", { keyPrefix: "STATISTICS.INCIDENCE.OPERATOR.TABLE" });
    
    // Agrupar por tipo de incidencia
    const groupedData = (operatorStatistics ?? []).reduce((acc, item) => {
        const key = item.incidenceType || "Sin tipo";
        if (!acc[key]) acc[key] = [];
        const { incidenceType, ...itemWithoutIncidenceType } = item;
        acc[key].push(itemWithoutIncidenceType as any);
        return acc;
    }, {} as Record<string, any[]>);

    const groupedList = Object.entries(groupedData).map(([type, items]) => ({
        incidenceType: type,
        items,
    }));

    const tableHeaderContent = (
        <>
            <div></div>
            <div>{t("CERTIFICATE_NUMBER")}</div>
            <div>{t("ORGANISM")}</div>
            <div>{t("TRANSPORT_UNIT_NUMBER")}</div>
            <div>{t("ENTITY_NAME")}</div>
        </>
    );
    
    const bodyContent = (
        <div className={style.container}>
            {groupedList.map((group, index) => {
                return (
                    <StatisticsOperatorIncidenceDetailedListIncidenceTypeItem
                        key={`incidence-group-${index}`}
                        incidenceTypeGroup={group}
                        index={index}
                    />
                );
            })}
        </div>
    );

    useEffect(() => {
        !operatorStatistics.length && !loading && dispatch(fetchStatiticsIncidenceOperatorDetailedFilterAction());
    }, []);

    return loading ? (
        <Skeleton rows={3}></Skeleton>
    ) : (
        <>
            <CustomTableList
                headerContent={tableHeaderContent}
                bodyContent={bodyContent}
            />
        </>
    );
};
